import { UserInfoKey } from "@/constants";
import { postApi } from "@apis/ajax";
function isEmptyObject(obj: any) {
  // 判断空对象
  for (var key in obj) {
    return false;
  }
  return true;
}
function isEqualObject(prevObj: any, nextObj: any) {
  if (!prevObj || !nextObj) return prevObj === nextObj;
  const prevProps = Object.getOwnPropertyNames(prevObj);
  const nextProps = Object.getOwnPropertyNames(nextObj);
  if (prevProps.length !== nextProps.length) return false;
  for (let i = 0; i < prevProps.length; i++) {
    const propName = prevProps[i];
    const prevObjValue = prevObj[propName];
    const nextObjValue = nextObj[propName];
    if (prevObjValue instanceof Object) {
      if (
        !Object.is(JSON.stringify(prevObjValue), JSON.stringify(nextObjValue))
      )
        return false;
    } else {
      if (!Object.is(prevObjValue, nextObjValue)) return false;
    }
  }
  return true;
}
function sort(a: any, b: any, type: any) {
  if (!a && !b) return;
  if (type === "DATE") {
    return new Date(a).getTime() - new Date(b).getTime();
  } else if (type === "EN") {
    return String(a).charCodeAt(0) - String(b).charCodeAt(0);
  } else if (type === "zh-CN") {
    return a.localeCompare(b, "zh-CN");
  }
}
function getCompany() {
  // 获取公司信息
  return JSON.parse(sessionStorage.getItem("company") || "{}");
}
function getUser() {
  // 获取用户信息
  return JSON.parse(sessionStorage.getItem("user") || "{}");
}
function exportFiles(url: any, queryParams: any, exportFileName?: any) {
  postApi(url)(queryParams, { responseType: "blob", observe: "response" }).then(
    ({ data, headers }) => {
      let filename = `${exportFileName}数据.xlsx`;
      if (headers["content-disposition"]) {
        filename = decodeURIComponent(
          headers["content-disposition"].split(";")[1].split("=")[1],
        );
      }
      const blob = new Blob([data], { type: "application/vnd.ms-excel" });
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(blobUrl);
    },
  );
}

function getStorageUser() {
  // 获取用户信息
  return JSON.parse(localStorage.getItem(UserInfoKey) || "{}");
}

function getCurrentDate(): string {
  // 获取当前日期（年月日格式: YYYY-MM-DD）
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export {
  isEmptyObject,
  sort,
  isEqualObject,
  getCompany,
  getUser,
  exportFiles,
  getStorageUser,
  getCurrentDate,
};
